module.exports = __webpack_public_path__ + "img/enj.9bd83db9.svg";